// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"214":"polyfills-core-js","748":"polyfills-dom"}[chunkId] || chunkId) + "." + {"214":"dfe3610a","340":"06454d93","748":"c5971dae"}[chunkId] + ".chunk.js";
};